import gql from 'graphql-tag';

const PAUSE_CAMPAIGN = gql`
  mutation pauseCampaign($id: String!) {
    pauseCampaign(id: $id) {
      id
      name
      status
    }
  }
`;

export default PAUSE_CAMPAIGN;
